import { createContext } from 'preact';

const UserPreferencesContext = createContext({});
export default UserPreferencesContext;